/**
 * Jobs class, filter logic and more
 *
 * @component
 */

import { debounce } from 'lodash/fp';
import ClassLogger from 'ClassLogger';
import Bookmarks from './../components/_bookmarks';

class Jobs {
    getClassName() { return 'Jobs'; }
    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);
    }

    init(sourceList) {
        let self = this;
        // init properties
        self.options = {
            perPage: 10,
        };

        if (sourceList == '' || typeof sourceList === 'undefined') {
            return;
        }
        self.logger.log('Jobs is running...');

        $(document).ready(function () {
            self.$component = $('[data-jobfilters]');
            self.$sourceList = $(sourceList);
            self.$resultList = self.$sourceList.prev($('[data-joblistresults]'));
            self.$moreButton = self.$sourceList.next($('[data-loadmore]'));

            self.filters = {};

            if (self.$sourceList.length === 0) return;

            $('select,input', self.$component).on('change',
                _.debounce(function (e) {
                    self.gatherFilters();
                    self.renderList();
                }, 1000, {
                    'leading': true,
                    'trailing': true
                })
            );

            $('.c-job-filtercriteria--hero select').on('change', function () {
                let name = $(this).attr('name');
                $('select[name="' + name + '"]', self.$component).val($(this).val()).trigger('change');
            });

            $('form.c-filter-teaser__form').on('submit', function (e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: ($('#jobs').offset().top - 100)
                }, 600);
                return false;
            });

            // init
            self.logger.log('Initializing...');
            self.gatherFilters();
            self.renderList();
        });
    }


    gatherFilters() {
        let self = this;
        let filters = {};
        self.$component.find('select,input').each(function (i, el) {
            let $el = $(el);
            let value = $el.val();
            let key = $el.attr('name');
            key = key.replace('filter-', '');

            // reset value for non-checked checkboxes
            if ($el.is('[type="checkbox"]') && !$el.is(':checked')) value = '';

            if (value !== '') {
                // add value to filters (with support for arrays of values...)
                if (key.endsWith('[]')) {
                    key = key.replace('[]', '');
                    if (typeof filters[key] !== 'object') filters[key] = [];
                    filters[key].push(value);
                } else {
                    filters[key] = value;
                }
                $el.addClass('is-active');
            } else {
                $el.removeClass('is-active');
            }
        });

        self.logger.info('Updated filters', filters);
        self.filters = filters;
        return self.filters;
    }


    renderList() {
        let self = this;
        let start = window.performance.now();

        // get keys of gathered filters
        let filterKeys = self.filters.constructor === Object ? Object.keys(self.filters) : [];
        let results = [];

        $('.c-jobblock', self.$sourceList).each(function (idx, jobblock) {
            let $jobblock = $(jobblock);
            let noMatch = false;
            filterKeys.forEach(function (key) {
                if (noMatch === true) return;
                if (self.filters[key] === null) return;
                let requestedValue = self.filters[key];
                let jobvalues = $jobblock.data(key);

                switch (key) {
                    case 'careerlevels':
                    case 'jobtypes':
                    case 'jobareas':
                        requestedValue = parseInt(requestedValue);
                        //self.logger.log('comparing: '+key, requestedValue, jobvalues);
                        if (jobvalues.length === 0) {
                            noMatch = true;
                        }
                        if (jobvalues.includes(requestedValue) === false) {
                            noMatch = true;
                        }
                        break;
                }
            });

            if (noMatch === false) {
                //self.logger.log('added '+$jobblock.find('.c-jobblock__headline').text());
                results.push({
                    jqObject: $jobblock.clone(true),
                    id: $jobblock.data('id'),
                    title: $jobblock.find('.c-jobblock__headline a').text(),
                    jobClass: $jobblock.data('class'),
                    companyPackage: $jobblock.data('package'),
                    sortdate: $jobblock.data('sortdate'),
                });
            } else {
                //self.logger.log('skipped '+$jobblock.find('.c-jobblock__headline').text());
                //$jobblock.hide();
            }
        });

        // update counter
        self.updateCounter(results.length);

        // sorting
        if (self.filters['sorting-premium'] == '1') {
            results.sort(function (a, b) {
                if (a.jobClass == 'topjob' && b.jobClass == 'topjob') {
                    if (a.sortdate > b.sortdate) {
                        return -1;
                    } else {
                        return 1;
                    }
                } else if (a.jobClass == 'topjob') {
                    return -1;
                } else if (b.jobClass == 'topjob') {
                    return 1;
                }

                if (a.companyPackage == b.companyPackage) {
                    if (a.sortdate == b.sortdate) {
                        return 0;
                    }
                    if (a.sortdate > b.sortdate) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
                if (a.companyPackage > b.companyPackage) {
                    return 1;
                } else {
                    return -1;
                }
            });

        } else {
            // first sort all entries by date
            results.sort(function (a, b) {
                // if they are equal, return 0 (no sorting)
                if (a.sortdate == b.sortdate) {
                    return 0;
                }
                if (a.sortdate > b.sortdate) {
                    // if b should come after a, return -1
                    return -1;
                } else {
                    // if a should come after b, return 1
                    return 1;
                }
            });

            // second: bring top jobs a little bit to the front...
            let idx = 0;
            let movedJobs = 0;
            results.forEach(function (job) {
                // stop if moved 3 topjobs to the front
                //if (movedJobs >= 3) return;

                let pageIdx = Math.ceil((idx + 1) / self.options.perPage);

                if (job.jobClass == 'topjob') {
                    if (idx >= 3) {
                        // move only if we're above position 3
                        let topjob = results.splice(idx, 1);
                        if (pageIdx === 1) {
                            // add to position 3 and follow (*2 leaves one slot for default-class jobs in between topjobs)
                            results.splice(3 + (movedJobs * 2), 0, topjob[0]);
                        } else {
                            results.splice(2 + (movedJobs * 3), 0, topjob[0]);
                        }
                    }

                    movedJobs++;
                }

                idx++;
            });


        }


        // show results
        if (results.length === 0) {
            self.$resultList.html('<p><em>Leider keine passenden Jobs gefunden. Bitte versuchen Sie einen Filter zu entfernen, um mehr Ergebnisse zu finden.</em></p>');
            window.location.hash = '';
            self.$moreButton.show();

        } else {

            self.$resultList.html('');

            let offset = 0;
            results.slice(offset, self.options.perPage).forEach(function (data) {
                self.$resultList.append(data.jqObject);
            });

            // refresh bookmarks
            let bookmarkRefresh = Bookmarks.init();

            self.$moreButton.off().on('click', function (e) {
                e.preventDefault();
                offset = offset + self.options.perPage;
                //self.logger.log('should load more', offset, (offset + self.options.perPage));

                results.slice(offset, (offset + self.options.perPage)).forEach(function (data) {
                    self.$resultList.append(data.jqObject);
                });

                if (offset + self.options.perPage >= results.length) {
                    self.$moreButton.hide();
                }

                // refresh bookmarks
                let bookmarkRefresh = Bookmarks.init();

                return false;
            });



            if (results.length <= self.options.perPage) {
                self.$moreButton.hide();
            } else {
                self.$moreButton.show();
            }

        }

        if (self.debug) {
            let end = window.performance.now();
            let dur = end - start;
            self.logger.log('renderList took ' + Math.round(dur) + 'ms. Found ' + results.length + ' results');
        }
    }


    updateCounter(count) {
        if (typeof count === 'undefined' || count === null) {
            count = $('.c-jobblock:visible', self.$resultList).length; //Math.floor(Math.random() * (1000 - 1) + 1);
        }
        $('#totalJobCount').text(count);
    }

}

export default Jobs;
